import { useEffect } from "react";

import { ThemeProviderContext, type Theme } from "./theme-context";

type ThemeProviderProps = {
  children: React.ReactNode;
  defaultTheme?: Theme;
  storageKey?: string;
};

const LIGHT: Theme = "light";

/**
 * Theme provider that always applies the light theme.
 *
 * The app is light mode only: whatever the store or the OS prefers is
 * ignored, and `setTheme` is a no-op. The dark CSS tokens are kept but never
 * active.
 *
 * @internal
 */
export function ThemeProvider({
  children,
  defaultTheme: _defaultTheme,
  storageKey: _storageKey,
  ...props
}: ThemeProviderProps) {
  useEffect(() => {
    const root = window.document.documentElement;
    root.classList.remove("dark", "system");
    root.classList.add(LIGHT);
  }, []);

  const value = {
    theme: LIGHT,
    setTheme: () => undefined,
  };

  return (
    <ThemeProviderContext.Provider {...props} value={value}>
      {children}
    </ThemeProviderContext.Provider>
  );
}
